module.exports = __webpack_public_path__ + "img/2x.91d2714.jpg";